import {Box, Chip} from '@mui/material';

type Props = {
  requestCostUsd: string | null;
  sessionCostUsd: string | null;
  requestLabel?: string;
  sessionLabel?: string;
  showSessionCost?: boolean;
};

const AgentCostBadge = ({
  requestCostUsd,
  sessionCostUsd,
  requestLabel = '今回',
  sessionLabel = 'セッション累計',
  showSessionCost = true
}: Props) => (
  <Box sx={{display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.75}}>
    <Chip size="small" variant="outlined" label={`${requestLabel} $${requestCostUsd ?? '--'}`} />
    {showSessionCost && (
      <Chip size="small" variant="outlined" label={`${sessionLabel} $${sessionCostUsd ?? '--'}`} />
    )}
  </Box>
);

export default AgentCostBadge;
